import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  
  @Input() name: string;
  @Input() label: string;
  @Input() type: string;
  @Input() placeholder: string;
  @Input() required: boolean;
  @Input() pattern: string;
  @Input() minlength: number;
  @Input() maxlength: number;
  @Output() keyPress = new EventEmitter();

  public form: FormGroup;
  public errors: {name: string, message: string}[] = []

  private errorMessages = {
    required: ' is required',
    pattern: ' is invalid',
    minlength: ' is too short',
  }

  constructor(private controlContainer: ControlContainer) { }

  ngOnInit(): void {
    this.form = <FormGroup>this.controlContainer.control;
  }

  triggerKeypress(event: KeyboardEvent): void {
    this.keyPress.emit(event);
  }

  checkErrors(): void {
    if (this.form && this.form.get(this.name).touched) {
      if (this.form.valid) {
        this.errors = [];
        return;
      }
      const entries = Object.entries(this.form.controls[this.name].errors || {});
      this.errors = entries
        .filter(([key, value]) => value)
        .map(([key, value]) => {
          const message = this.errorMessages[key]
            ? this.label + ' ' + this.errorMessages[key]
            : 'Invalid';
          return {name: key, message };
        });
    }
  }
}
